import { ref } from 'vue'

export function useTab() {
  const currentTabIndex = ref('1')

  function activeTabContent(index: number) {
    currentTabIndex.value = index
  }

  return {
    currentTabIndex,
    activeTabContent,
  }
}
